import { Controller } from "stimulus";
import { SearchItemContainer } from '../search/search_item_container';
import { searchFormHelpers } from '../search/search_form_helpers';
import { searchFormFlex } from '../listings/search_form_flex';
import {
  normalizeListingIdsFromExpandedString,
  mlsResolutionSignatureForHiddenContainer
} from './mls_number_input_helpers';

// Mirrors mls_number_input_controller but for the regular ListingId filter
// container on non-MLS-# search pages. No numeric-range expansion and no tip
// text, just resolve user-typed ListingIds to ListingKeys so the saved filter
// uses ListingKey (Spark rejects ListingId when multiple MlsIds are selected).
export default class extends Controller {
  static targets = ["input", "hiddenContainer"]

  connect() {
    this._resolving = false;
  }

  handleKeydown(evt) {
    if (evt.key === 'Enter') {
      evt.preventDefault();
      this.inputChanged();
    }
  }

  inputChanged() {
    if (this._resolving) return;

    const $card = $(this.element);
    const rawValue = this.inputTarget.value.trim();

    if (rawValue.length === 0) {
      const prevSig = this._resolutionSignature();
      const prevSummary = this._cardSummaryText($card);
      this._clearHiddenFields();
      SearchItemContainer.updateContainerSummaryText($card, '');
      SearchItemContainer.checkContainer($card, false);
      if (prevSig !== '' || prevSummary !== '') {
        this._triggerFormReload();
      }
      return;
    }

    this._resolveListingIds(rawValue);
  }

  _resolveListingIds(displayValue) {
    this._resolving = true;

    const data = { listing_ids: displayValue };

    const mlsIdSelect = document.querySelector('#search_fields_MlsId_value');
    if (mlsIdSelect) {
      const selectedValues = $(mlsIdSelect).val();
      if (selectedValues && selectedValues.length > 0) {
        data.mls_id = selectedValues;
      }
    }

    $.ajax({
      url: routes.resolve_mls_numbers_path(),
      type: 'POST',
      data: data,
      success: (response) => {
        this._resolving = false;
        const listings = response.listings || [];

        const $card = $(this.element);
        const prevSig = this._resolutionSignature();
        const prevSummary = this._cardSummaryText($card);
        const displayTrimmed = displayValue.trim();

        this._clearHiddenFields();

        if (listings.length > 0) {
          listings.forEach((listing) => {
            const hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'search_fields[ListingKey][value][]';
            hidden.value = listing.listing_key;
            this.hiddenContainerTarget.appendChild(hidden);
          });

          SearchItemContainer.checkContainer($card, true);
        } else {
          const tokens = normalizeListingIdsFromExpandedString(displayValue);
          if (tokens.length > 0) {
            tokens.forEach((token) => {
              const hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = 'search_fields[ListingId][value][]';
              hidden.value = token;
              this.hiddenContainerTarget.appendChild(hidden);
            });

            SearchItemContainer.checkContainer($card, true);
          }
        }

        SearchItemContainer.updateContainerSummaryText($card, displayValue);

        const newSig = this._resolutionSignature();
        const sigChanged = prevSig !== newSig;
        const displayChanged = prevSummary !== displayTrimmed;
        if (sigChanged || displayChanged) {
          this._triggerFormReload();
        }
      },
      error: () => {
        this._resolving = false;
      }
    });
  }

  _clearHiddenFields() {
    this.hiddenContainerTarget.innerHTML = '';
  }

  _resolutionSignature() {
    return mlsResolutionSignatureForHiddenContainer(this.hiddenContainerTarget);
  }

  _cardSummaryText($card) {
    return $card.find('.c-card-enable-summary').text().trim();
  }

  _triggerFormReload() {
    const serializedForm = searchFormHelpers.formSerializer();
    searchFormFlex.reloadData(serializedForm, false);
  }
}
